<template>
    <div>
        <router-link to="/">
            <v-img class="img-logo-nl"  alt="logo" src="@/assets/img/logo-genl.svg"></v-img>
        </router-link>

        <v-container class="d-flex align-self-center justify-center align-self-center pt-mobile"  style="height:100vh" >
            <v-row align="center" justify="center" class="align-self-center justify-center d-flex align-center" style="max-width:800px;"  >

                <v-card class="pa-6 align-self-center justify-center"  v-if="!previewDocument">
                    <!-- <v-img class="logo_tam" alt="Tamaulipas Logo" src="@/assets/img/logo_nl.png"></v-img> -->
                    <v-card-title class="my-5 text-center poppinsBold justify-center brown--text" style="word-break: break-word;"  >{{txtTitle}}</v-card-title>

                    <v-divider></v-divider>

                    <v-card-subtitle class="my-5 text-center poppinsRegular justify-center d-flex"   >
                        <v-card
                        flat
                        max-width="70%"
                        class="blue-grey--text text--darken-4"
                        >
                        {{txtSubTitle}}
                        </v-card>
                    </v-card-subtitle>

                    <v-card class="my-5 text-center poppinsRegular justify-center d-flex" flat>
                        <v-card 
                        color="#fff5d3"
                        max-width="100%"
                        flat
                        class="px-5"
                        >
                        <span class="brown--text ">Nota: </span>{{txtNota}}

                        </v-card>
                    </v-card>

                    <v-card-text class="mt-6 justify-center text-center d-flex flex-column">
                        <!-- LOGIN FORM -->
                        <label for="" class="label-form ">Ingresa aquí el código</label>
                        <v-card flat class="d-flex justify-center">
                            <v-text-field
                                class="justify-center poppinsMedium"
                                style="max-width:100%"
                                outlined required
                                label=""
                                v-model="documentCode"
                                :rules="[value => !!value || 'El campo es requerido.']"
                            />
                        </v-card>
                        <v-row class="pl-2 mt-2 justify-center mb-0 ">
                        <vue-recaptcha
                            :sitekey="getCaptchaSiteKey()"
                            :loadRecaptchaScript="true"
                            @verify="verifyReCaptcha"
                            @expired="expiredRecaptcha"
                        >
                        </vue-recaptcha>
                        </v-row>
                        <p class="pb-5 poppinsRegular-sm">Haz click en el recuadro blanco ubicado en la izquierda</p>
                    </v-card-text>


                    <v-card-actions>
                        <v-row align="center" class="justify-space-around mb-15">
                            <div class="d-flex flex-row">
                                <v-btn @click="validate()" :color="pantoneBlack" large class=" white--text rounded-md flex-fill mr-2 poppinsMedium">Validez del Pago</v-btn>
                                <!-- <v-btn @click="cancelValidate()" :color="pantoneBlack" large class="white--text rounded-md flex-fill ml-2 poppinsMedium">Cancelar</v-btn> -->
                            </div>
                        </v-row>
                    </v-card-actions>

                </v-card>


            </v-row>

        </v-container>

       <div>
           <v-dialog
                v-model="dialog"
                width="500"
                persistent
            >
                <v-card v-if="validationResult">
                    <v-card-title class="text-h5">
                     Resultado 
                    </v-card-title>
                    <v-divider></v-divider>

                    <v-card-text class="mt-3">
                        {{validationResult.msg}}
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialog = false" > Ok </v-btn>
                    </v-card-actions>
                </v-card>

            </v-dialog>
       </div>
    </div>

</template>

<script>
import {mapActions, mapState} from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
// import {GeneralApi} from "bestgob-core/api";
// import {toFormData} from "bestgob-core/core/utils";

export default {
    name:"paiment_validate",
    data() {
        return {
            pantone: '#B08C55',
            pantoneBlack: '#15212F',
            documentCode: null,
            recaptchaVerified: false,
            formValid: false,
            showPassword: false,
            showRepeatPassword: false,
            documentImages: null,

            previewDocument: false,
            documentValid: false,
            txtTitle: 'CONSULTAR ESTATUS DEL PAGO',
            txtSubTitle: 'Si tu pago lo hiciste a través del formato referenciado, se recomienda verificar periódicamente tu folio de seguimiento',
            txtNota:'Recuerda que pueden pasar hasta 72 horas hábiles para que el pago se vea reflejado',
            colorTitle:'#B08C55',
            dialog: false,
        }
    },

    components: {VueRecaptcha},

    computed: {
        ...mapState({accountStore: state => state.account, alertsStore: state => state.alerts}),

        validationResult(){
            return this.$store.state.processes.documentStatusSucces
        }
    },

    watch:{
        validationResult(){
            this.dialog = true
            this.validationResult.status ? (this.result = true) : this.result = false
            this.validationResult.url != '' ? window.open(this.validationResult.url) : 0
        }
    },

    mounted() {
        if (this.$route.query.code !== undefined){
            this.documentCode = this.$route.query.code
        }
    },
    methods: {
        ...mapActions('account', ['setNewUserPassword']),
        ...mapActions('alerts', ['success', 'error', 'showLoading', 'hideLoading']),
        ...mapActions('processes', ['getDocumentByPaymentStatus','documentStatusSucces']),


        validate(){
            this.getDocumentByPaymentStatus(this.documentCode)    
        },

        validatePageReset(){
            location.reload();
        },

        getCaptchaSiteKey(){
            return process.env.VUE_APP_RECAPTCHA_SITE_KEY
        },

        verifyReCaptcha(){
            this.recaptchaVerified = true
        },

        expiredRecaptcha(){
            this.recaptchaVerified = false
        },

        cancelValidate(){
            if (this.accountStore.loggedIn){
                this.$router.push({name: 'home'})
            }else{
                this.$router.push({name: 'login'})
            }
        }
    },

};
</script>
<style>

    .theme--light.v-divider {
        border-color: #ff840059;
        height: 3px !important;
        border-width: thin 0px  1px  0px;
    }
    .relative {position: relative}
    .absolute {position: absolute}
    .fb-native-button{width: 100%;}
    .fb-native-button button{
        height: 36px;
        background-image: none !important;
        padding: 0 !important;
        min-width: 0 !important;
        width: 100%
    }
    .fb-native-button button img, .fb-native-button button .spinner{display: none}
    .poppinsBold{
        font-family: "PoppinsBold" !important;
        font-size: 20pt;
    }
    .poppinsMedium{
    font-family: "PoppinsMedium" !important;
    font-size: 100px;
    }
    .poppinsRegular{
        font-family: "PoppinsRegular" !important;
        font-size: 15pt;
    }
    .poppinsRegular-sm{
        font-family: "PoppinsRegular" !important;
        font-size: 10pt;
    }
    .img-logo-nl{
        width:200px;
        position: absolute;
         top:5%;
         margin-left: auto;
         margin-right: auto;
         left: 0;
         right: 0;
    }
     /* .v-input__slot{
        align-items: center;
        color: inherit;
        display: flex;
        min-height: inherit;
        width: 100%;
        padding: .9rem  1rem !important;
        font-size: .7rem;
        line-height: 1.5;
        border-radius: 10px;
        display: flex;
        color: #ff8400 !important;
        background-color: #fff !important;
        background-clip: padding-box;
        border: 1px  solid #ff8400;
        border-radius: 0.25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }     */
    
    .v-application.fondo_login fieldset{
        border-bottom: 0px !important
    }
    @media only screen and (max-width: 770px) {
            .pt-mobile{
                margin-top: 20%;
            }
    }
</style>
